import { Icon } from "@clarkinc/zest-design-system";
import { cls } from "@wss/cls";
import React, { useState } from "react";
import { Image } from "@wss/image";
import { Video } from "~/common/Store/models/Video";
import ZestVideoPlayer from "~/common/videoPlayer/ZestVideoPlayer";
interface Props {
  videos: Video[];
  autoPlayOnVideoSwap: boolean;
}
const buttonOptionsList = ["Transcript", "Embed"];
const VideoSpotlight = ({
  videos,
  autoPlayOnVideoSwap
}: Props) => {
  const [autoPlayVideo, setAutoPlayVideo] = useState(false);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);
  const [selectedButton, setSelectedButton] = useState(buttonOptionsList[0]);
  const selectedVideo = videos[selectedVideoIndex];
  const setSelectedVideo = (videoIndex: number) => {
    setSelectedVideoIndex(videoIndex);
    if (autoPlayOnVideoSwap) {
      setAutoPlayVideo(true);
    }
  };
  const videosToSpotlight = videos?.length ? videos.filter(video => !video.isModelingVideo) : [];
  return <>
      <div className="detail-section video-template">
        <div className="clears" />
        <div className="video-media video">
          <div className="videofill rounded-none">
            {!!videos?.length && selectedVideo !== undefined && <div id={`vid${selectedVideo.id}`} data-testid={selectedVideo.id} className={`video-container vid${selectedVideoIndex}`}>
                <ZestVideoPlayer key={`videoSpotlight-${selectedVideo.id}`} videoSection="XD" data-testid={`videoSpotlightPlayer-${selectedVideo.id}`} posterImage={selectedVideo.poster} sources={selectedVideo.sources} currentIndex={0} selected={0} youtubeId={selectedVideo.youtubeId} closedCaptionsrc={selectedVideo.closedCaptionFile} title={selectedVideo.title} autoPlay={autoPlayVideo} playsInline videoClasses="rounded-normal" controlsProps={{
              className: "rounded-b-normal"
            }} />
              </div>}
          </div>
          {videos.length > 1 && <div className="product-videos">
              <p className="header-5">Watch More Videos</p>
              <div className="video-thumbnails shadow-container shadow-right">
                <ul className="video-overflow container-overflow">
                  {videos.map((video, index) => <li key={video.id}>
                      <a className="item vid-item video-ui" style={index > 0 ? {
                  left: `${index * 4}px`
                } : {}} href={`#${video.id}`} onClick={() => setSelectedVideo(index)}>
                        <Image alt={video.title} src={`https://cdn.webstaurantstore.com${video.poster}`} loading="lazy" height={62.75} width={110} />
                      </a>
                    </li>)}
                </ul>
              </div>
            </div>}
        </div>
        <div className="video-content">
          {selectedVideo !== undefined && <>
              <div>
                <div className={`video-container vid${selectedVideoIndex}`}>
                  <h2>{selectedVideo.title}</h2>
                  <div className="about mb-6">
                    <p className="mb-0" dangerouslySetInnerHTML={{
                  __html: selectedVideo.description || ""
                }} />
                    <div className={cls("flex", "items-center", "group")}>
                      <a href={selectedVideo.seoUrl} target="video" className={cls("text-green-500", "font-semibold", "text-sm", "active:text-green-800", "group-hover:text-green-700", "group-hover:underline")}>
                        More Video Resources
                      </a>
                      {!!videosToSpotlight?.length && <Icon name="ri-arrow-right-s-line" theme="wss" size="xsmall" className={cls("fill-green-500", "mr-0.5", "group-hover:fill-green-700")} />}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className={`video-content-box vid${selectedVideoIndex}`}>
                  <div className="btn-group">
                    {buttonOptionsList.map(button => <button key={button} type="button" className={`btn btn-mini btn-light ${selectedButton === button ? "active" : ""}`} style={{
                  marginRight: "0px"
                }} onClick={() => setSelectedButton(button)}>
                        {button}
                      </button>)}
                  </div>
                  <div className="clearfix" />
                  <div className="overflow">
                    <div>
                      <div>
                        {selectedButton === "Transcript" && <div className="transcript">
                            {selectedVideo.transcript ? <p dangerouslySetInnerHTML={{
                        __html: selectedVideo.transcript || ""
                      }} /> : "No Video Transcript entered."}
                          </div>}
                        {selectedButton === "Embed" && <div className="embed">
                            <textarea className="EmbedInfo" readOnly value={`<div><iframe scrolling="no" width="392" height="226" src="https://www.webstaurantstore.com/v/?num=${selectedVideo.id}&embed=1" frameBorder="0"></iframe>Courtesy of <a href="https://www.webstaurantstore.com">WebstaurantStore Restaurant Supplies</a></div>`} />
                            <br />
                            <i>Copy and paste the embed code above.</i>
                          </div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>}
        </div>
      </div>
      <div className="clears" />
    </>;
};
export default VideoSpotlight;